var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("records_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('records_page.form_desc'))
    }
  }), _vm.getModuleConfig('records_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('apply_page.content'))
    }
  }) : _vm._e(), _vm.showFilter ? _c('coupon-filters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }) : _vm._e(), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.currentData.coupons.length > 0 ? _c('div', [_vm._l(_vm.currentData.coupons, function (item, index) {
    var _vm$couponModels$inde;
    return _c('coupon-card', {
      key: index,
      attrs: {
        "coupon": item,
        "buttonText": item.status == 'applied_and_not_yet' ? '尚未開始' : '查看',
        "showCode": _vm.codeIsVisibleInList && ((_vm$couponModels$inde = _vm.couponModels[index]) === null || _vm$couponModels$inde === void 0 ? void 0 : _vm$couponModels$inde.isInRedeemableTimeRange())
      },
      on: {
        "exchange": _vm.showCouponModal
      }
    });
  }), _c('Pagination', {
    staticStyle: {
      "margin": "32px auto 50px"
    },
    attrs: {
      "total-page": _vm.currentData.meta.lastPage,
      "has-next": _vm.currentData.meta.hasNext
    },
    on: {
      "input": _vm.handlePageIsChanged
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 2) : _c('coupon-empty')], 1), _c('coupon-modal', {
    ref: "couponModal",
    attrs: {
      "coupon": _vm.selectedCoupon,
      "showCode": _vm.codeIsVisibleInDetail,
      "showQrcodeButton": _vm.showQrcodeButton
    },
    on: {
      "confirmed": _vm.refresh
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }